import { render } from "./LHDNLogs.vue?vue&type=template&id=0167be4c&scoped=true"
import script from "./LHDNLogs.vue?vue&type=script&lang=js"
export * from "./LHDNLogs.vue?vue&type=script&lang=js"

import "./LHDNLogs.vue?vue&type=style&index=0&id=0167be4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0167be4c"]])

export default __exports__